// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__bmXmu","employee-header-item":"Header_employee-header-item__a3BgR"};